/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { Drawer, Box, styled, Typography, Divider, IconButton, Grid, Button, FormControl, InputLabel, OutlinedInput, Autocomplete, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { EnterpriseAccess, TemplateType } from '../../../common/const';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiRequest } from '../../../common/common';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import { LoadingPage } from '../../../common/LoadingPage';
import { useEffect } from 'react';
import ImageIcon from '@mui/icons-material/Image';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 60
}));

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
    paddingTop: 10
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

export default function CreateModule({
    open,
    setOpen,
    isTemplate,
    setIsTemplate,
    selectedItem,
    setSelectedItem,
    selectedDep,
    getData,
    templateItem
}) {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
    const [dataLoading, setDataLoading] = useState(false);
    const [departmentName, setDepartmentName] = useState(selectedItem?.department_name || templateItem?.room_name || null);
    const [templateType, setTemplateType] = useState(selectedItem?.type || TemplateType[1]?.value);
    const [description, setDescription] = useState(selectedItem?.description || templateItem?.description || null);
    const [planningTips, setPlanningTips] = useState(selectedItem?.planning_tips || templateItem?.planning_tips || null);
    const [errors, setErrors] = useState({});
    const [imageURL, setImageURL] = useState(templateItem?.thumbnail || '');

    useEffect(() => {
        if (selectedItem) {
            setDepartmentName(selectedItem?.department_name);
            setTemplateType(selectedItem?.type);
            setDescription(selectedItem?.description);
            setPlanningTips(selectedItem?.planning_tips);
        }
    }, [selectedItem]);
    const handleClose = () => {
        setOpen(false);
        setErrors({});
        setDepartmentName(null);
        setTemplateType(TemplateType[1]?.value);
        setDescription(null);
        setPlanningTips(null);
        setIsTemplate(false);
        setImageURL('');
        setSelectedItem(null);
    }

    const handleSubmit = async () => {
        const newErrors = {};

        if (!departmentName) {
            newErrors.name = isTemplate ? 'Department Name is required' : 'Room Name is required';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setDataLoading(true);
            let data;
            if (!isTemplate) {
                data = {
                    room_name: departmentName,
                    description: description,
                    planning_tips: planningTips,
                    quantity: 1,
                    thumbnail: imageURL,
                    status: 'active',
                    dept_template_id: templateItem?.dept_template_id || selectedDep[0].dept_template_id,
                    organization_id: user?.organization?.organization_id,
                    created_by: user?.user_id,
                }
                setDataLoading(false);
                try {
                    let response;
                    if (templateItem !== null) {
                        response = await apiRequest('put', `/template/room/${templateItem?.room_template_id}`, data);
                    } else {
                        response = await apiRequest('post', `/template/room`, data);
                    }
                    if (response?.data) {
                        if (templateItem !== null) {
                            templateItem.thumbnail = imageURL;
                            templateItem.room_name = departmentName;
                            templateItem.description = description;
                            templateItem.planning_tips = planningTips;
                        }
                        setDataLoading(false);
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                        getData(1, 'public', data);
                        getData(1, 'personal', data);
                        getData(1, 'organization', data);
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else {
                data = {
                    department_name: departmentName,
                    type: templateType,
                    description: description,
                    planning_tips: planningTips,
                    organization_id: user?.organization?.organization_id,
                    user_id: user?.user_id,
                    status: 'active'
                };
                try {
                    if (selectedItem) {
                        const response = await apiRequest('put', `/template/${selectedItem?.dept_template_id}`, data);
                        if (response?.data) {
                            setDataLoading(false);
                            showNotification(response?.data?.message, 'success');
                            handleClose();
                            getData(1, 'public');
                            getData(1, 'personal');
                            getData(1, 'organization');
                        }
                    } else {
                        const response = await apiRequest('post', '/template', data);
                        if (response?.data) {
                            setDataLoading(false);
                            showNotification(response?.data?.message, 'success');
                            handleClose();
                            getData(1, 'public');
                            getData(1, 'personal');
                            getData(1, 'organization');
                        }
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        }
    }

    return (
        <Drawer
            anchor="right"
            open={open}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 350
                }
            }}
        >
            <CustomFilterPanelWrapper>
                {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                <DemoBox1>
                    <Typography variant='body1' style={{ fontWeight: 'bold' }}>{isTemplate ? 'Create Template' : 'Create Room Template'}</Typography>
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </DemoBox1>
                <Divider />
                <FilterContent>
                    <Grid container spacing={2}>
                        {!isTemplate && (
                            <Grid item xs={12} display="flex" justifyContent="center">
                                {imageURL !== '' ? (
                                    <Box
                                        style={{
                                            height: 58,
                                            width: 100,
                                            border: '1px solid lightgray',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'relative',
                                        }}
                                    >
                                        <img
                                            src={imageURL}
                                            alt="thumbnail"
                                            style={{
                                                width: '58%'
                                            }}
                                        />
                                        <ClearIcon
                                            onClick={() => setImageURL('')}
                                            style={{
                                                position: 'absolute',
                                                top: 3,
                                                right: 3,
                                                cursor: 'pointer',
                                                fontSize: 15
                                            }}
                                        />
                                    </Box>
                                ) : (
                                    <Box
                                        style={{
                                            height: 58,
                                            width: 100,
                                            border: '1px solid lightgray',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer'
                                        }}
                                        component="label"
                                    >
                                        <ImageIcon style={{ color: 'lightgray' }} />
                                        <VisuallyHiddenInput
                                            type="file"
                                            onChange={async (event) => {
                                                setDataLoading(true);
                                                const formData = new FormData();
                                                formData.append('filepath', 'template');
                                                formData.append('files', event.target.files[0]);
                                                try {
                                                    const response = await apiRequest('post', `/template/upload-files`, formData);
                                                    if (response?.data) {
                                                        const { path } = response?.data?.data?.[0];
                                                        const imageUrl = `${process.env.REACT_APP_IMAGEURL}/template/${path.split('/').pop()}`
                                                        setImageURL(imageUrl);
                                                        showNotification(response?.data?.message, 'success');
                                                        setDataLoading(false);
                                                    }
                                                } catch (error) {
                                                    setDataLoading(false);
                                                    showNotification(error?.response?.data.error || error.message, 'error');
                                                }
                                            }}
                                            accept='.jpeg,.jpg,.png,.PNG'
                                        />
                                    </Box>
                                )}
                            </Grid>)}
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">{isTemplate ? 'Department Name *' : 'Room Name *'}</InputLabel>
                                <OutlinedInput
                                    label={isTemplate ? 'Department Name *' : 'Room Name *'}
                                    id="standard-adornment-password"
                                    type='text'
                                    value={departmentName || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (!e.target.value) {
                                            newErrors.name = isTemplate ? 'Department Name is required' : 'Room Name is required';
                                        } else {
                                            newErrors.name = '';
                                        }
                                        setErrors(newErrors);
                                        setDepartmentName(e.target.value);
                                    }}
                                />
                                <Typography variant='body2' style={{ color: 'red' }}>{errors.name}</Typography>
                            </FormControl>
                        </Grid>
                        {isTemplate ? (
                            <Grid item xs={12}>
                                <Autocomplete
                                    value={TemplateType.find((c) => c.value === templateType) || null}
                                    id="combo-box-demo"
                                    size="small"
                                    fullWidth
                                    options={TemplateType}
                                    getOptionLabel={(option) => option?.name}
                                    getOptionDisabled={(option) => {
                                        if (option?.name === 'Mvedas') {
                                            return !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);
                                        }
                                        if (option?.name === 'Organization') {
                                            return EnterpriseAccess !== currentPlanId && !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);
                                        }
                                        return false;
                                    }}
                                    clearIcon={null}
                                    onChange={(event, newValue) => {
                                        setTemplateType(newValue?.value)
                                    }}
                                    renderInput={(params) => <TextField fullWidth {...params} label="Template Type" name="Template Type" variant="outlined" />}
                                />
                            </Grid>
                        ) : ''}
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">{isTemplate ? 'Department Description' : 'Room Description'}</InputLabel>
                                <OutlinedInput
                                    multiline
                                    maxRows={5}
                                    minRows={4}
                                    label={isTemplate ? 'Department Description' : 'Room Description'}
                                    id="standard-adornment-password"
                                    type='text'
                                    value={description || ''}
                                    onChange={(e) => {
                                        setDescription(e.target.value);
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Planning Tips</InputLabel>
                                <OutlinedInput
                                    multiline
                                    maxRows={5}
                                    minRows={4}
                                    label="Planning Tips"
                                    id="standard-adornment-password"
                                    type='text'
                                    value={planningTips || ''}
                                    onChange={(e) => {
                                        setPlanningTips(e.target.value);
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </FilterContent>
                <FilterFooter>
                    <FixedButton variant="outlined" color="primary" onClick={() => handleClose()}>Cancel</FixedButton>
                    <FixedButton variant="contained" color="primary" onClick={() => handleSubmit()}>Save</FixedButton>
                </FilterFooter>
            </CustomFilterPanelWrapper>
        </Drawer>
    );
}